import React, {useMemo} from "react";
import {Grid} from "@mui/material";
import {BrightnessLowOutlined, CheckCircleOutlined, EnergySavingsLeafOutlined, SsidChartOutlined} from "@mui/icons-material";
import DailyReportTotalizerCard from "./DailyReportTotalizerCard";
import {useDailyReportTotalizersQuery} from "../reactQuery/DailyReportTotalizersReactQuery";

interface DailyReportTotalizersProps {
    selectedDate: string | null;
    powerStationIds?: number[] | null;
}

const formatTotalizer = (value: number | null | undefined): string => {
    return new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    }).format(value ?? 0);
};

export default function DailyReportTotalizers({selectedDate, powerStationIds}: DailyReportTotalizersProps) {
    const {data, isLoading} = useDailyReportTotalizersQuery(selectedDate, powerStationIds);

    const cards = useMemo(
        () => [
            {
                icon: <EnergySavingsLeafOutlined/>,
                title: "Energia Gerada",
                value: formatTotalizer(data?.generatedEnergy),
                unit: "MWh",
                subtitle: "Total gerado no dia",
            },
            {
                icon: <BrightnessLowOutlined/>,
                title: "Irradiação",
                value: formatTotalizer(data?.irradiance),
                unit: "kWh/m²",
                subtitle: "Total irradiado no dia",
            },
            {
                icon: <SsidChartOutlined/>,
                title: "PR Médio",
                value: formatTotalizer(data?.performanceRatio),
                unit: "%",
                subtitle: "Performance ratio médio",
            },
            {
                icon: <CheckCircleOutlined/>,
                title: "Disponibilidade Média",
                value: formatTotalizer(data?.operationAvailability),
                unit: "%",
                subtitle: "Disponibilidade consolidada",
            },
        ],
        [data]
    );

    return (
        <Grid container spacing={2}>
            {cards.map((card) => (
                <Grid item xs={12} sm={6} md={3} key={card.title}>
                    <DailyReportTotalizerCard
                        icon={card.icon}
                        title={card.title}
                        value={card.value}
                        unit={card.unit}
                        subtitle={card.subtitle}
                        loading={isLoading}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
